import React from 'react';
import { Motion, spring, presets } from 'react-motion';

export default class Animate extends React.Component {
  render () {
    return (
      <Motion defaultStyle={{ opacity: 0.5 }} style={{ opacity: spring(1, presets.gentle) }}>
        {
          config =>
            <div style={{ opacity: config.opacity }} {...this.props}>
              {this.props.children}
            </div>
        }
      </Motion>
    );
  }

}



// WEBPACK FOOTER //
// ./src/common/views/Animate.js